import { EventBus } from "../../../eventbus";

export default {
  data() {
    return { id: this.$options.name };
  },
  created() {
    EventBus.$on(`${this.id}-selectItems`, this.selectItems);
  },
  methods: {
    selectItems() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      }
    },
    filesSelected() {
      //got to the next step with the selected files
      EventBus.$emit(`mobile-upload-updateStep`, {
        id: "upload-preview",
        data: {
          files: this.$refs.fileInput.files,
        },
      });
    },
  },
};
